<template>
    <div>
        <answer-header type="back" :title="langMap[lang].mygift1"></answer-header>
        <div class="blk1">
            <div class="txtcenter fz32">ID: {{id}}</div>
        </div>
        <div class="blk2">
            <div class="empty" v-if="!list || list.length==0">{{langMap[lang].mygift2}}</div>
            <ul class="gift-list" v-else>
                <li :class="{'gift-item':true, 'flex-group':true, 'flex-between':true, 'gift-item-active':(item.status==3)}" v-for="item in list">
                    <span class="fz32">{{item.code}}</span>
                    <span>{{_statusText(item.status)}}</span>                      
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Mygift',
    components: {answerHeader},
    data(){
        return {
            id: '',
            list: []
        }
    },
    computed: {
        ...mapState(['lang','langMap'])
    },
    created(){
        this._fetchUserInfo();
        this._fetchGiftList()
    },
    methods: {
        _fetchUserInfo(){
            Utils.$ajax({
                url: '?r=center',
            }).done(res=>{
                if(res.code!=0){
                    this.$toast(res.msg);
                    return;
                }
                this.id = res.data.memberId;
            })
        },
        _fetchGiftList(){
            Utils.$ajax({
                url: '?r=exchange/record',
            }).done(res=>{
                if(res.code!=0){
                    this.$toast(res.msg);
                    return;
                }
                this.list = res.data;
            })
        },
        _statusText(s){
            var lm = this.langMap[this.lang],
                map = {'1':lm.mygift3, '2':lm.mygift4, '3':lm.mygift5};

            return map[s]
        }
    }
}
</script>

<style lang="scss" scoped>
    @function rem($px) {
      @return $px/100+rem;
    }
    .blk1{
        margin-top: rem(130);
    }
    .blk2{
        margin-top: rem(80);
        .empty{
            font-size: rem(30);
            text-align: center;
            color: #bbb;
            padding-top: rem(100);
        }
        .gift-item{
            color: rgba(255,255,255,.3);
            border-top: 1px rgba(255,255,255,.3) dashed;
            padding: rem(20) 0;
            &:last-child{
               border-bottom: 1px rgba(255,255,255,.3) dashed; 
            }
            &.gift-item-active{
                color: rgba(255,255,255,1);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Mygift.vue